import styled from 'styled-components/macro'

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  margin-top: -88;
  gap: 8px;

  @media (max-width: 768px) {
    width: 100%;
    justify-content: space-between;
    padding: 8px 16px;

    .stat {
      flex: 1;
    }

    label {
      padding-left: 0;
      margin-top: 8px;
    }
  }

  .cards {
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 100%;
    gap: 8px;

    .stat {
      background: ${props => props.theme.white};
      border-radius: 8px;
      padding: 8px 12px;
      min-width: 110px;

      span {
        font-size: 14px;
        font-weight: 500;
      }

      .stat-value {
        font-weight: 500;
        font-size: 30px;
        color: ${props => props.theme.accent};
      }

      svg {
        color: ${props => props.theme.green};
        font-size: 14px;
      }

      @media (max-width: 768px) {
        flex: 1;
      }
    }
  }
`
